import { useEffect, useRef, useState } from "react";

import { Col, Row } from "react-bootstrap";
import { Team } from "../types/teams";
import DriverRankBadge from "../components/driverRank";
import SafetyRankBadge from "../components/safteyRank";

import { getImage, Paint } from "../types/Paint";
import PaintServiceClient from "../services/paint-service.client";

export interface Props {
  team: Team;
}

const ViewTeam: React.FC<Props> = ({ team }) => {
  const ps = useRef<PaintServiceClient>(new PaintServiceClient());

  const [paints, setPaints] = useState<Paint[]>([]);
  const [paintError, setPaintError] = useState<Paint[]>([]);
  const [paintQueueCount, setPaintQueueCount] = useState<number>(0);
  const [paintErrorCount, setPaintErrorCount] = useState<number>(0);

  const [showPaints, setShowPaints] = useState<boolean>(false);
  const [showPaintError, setShowPaintError] = useState<boolean>(false);

  useEffect(() => {
    ps.current.getTeamPaints(team.id)
      .then((paints: Paint[]) => {
        setPaints(paints);
      })
      .catch((err: Error) => {
        console.error(err);
      });

    ps.current.getPaintQueue(team.id)
      .then((queue: number) => {
        setPaintQueueCount(queue);
      })
      .catch((err: Error) => {
        console.error(err);
      });

    ps.current.getPaintError(team.id)
      .then((error: number) => {
        setPaintErrorCount(error);
      })
      .catch((err: Error) => {
        console.error(err);
      });

    ps.current.getPaintsByStatus(team.id, "error")
      .then((paints: Paint[]) => {
        setPaintError(paints);
      })
      .catch((err: Error) => {
        console.error(err);
      });
  }, []);

  const toggleShowPaints = () => {
    setShowPaints(!showPaints);
    setShowPaintError(false);
  };

  const toggleShowPaintError = () => {
    setShowPaintError(!showPaintError);
    setShowPaints(false);
  };


  return (
    <div>
      <h1>{team.name}</h1>
      <hr />
      <p>{team.description}</p>

      <Row>
        <Col>
          <h2>Paints</h2>
          <div>
          <p>
            In Queue: {paintQueueCount} | <span onClick={() => toggleShowPaintError()}>In Error: {paintErrorCount}</span> | <span onClick={() => toggleShowPaints()}>Total: {paints.length}</span>
          </p>
          </div>
        </Col>
      </Row>

      {showPaints && (
        <Row>
          <Col>
            <h3>Paints</h3>
            <div style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
              {paints.map((paint) => (
              <img
                key={paint.id}
                src={getImage(paint)}
                alt={paint.vehicleId}
                className="paint-image"
                height="75px"
                width="auto"
              />
              ))}
            </div>
          </Col>
        </Row>
      )}

      {showPaintError && (
        <Row>
          <Col>
            <h3>Paint Errors</h3>
            <div>
            {paintError.map((paint) => (
              <div key={paint.id} className="paint-item">
                <a href={paint.uri} target="_blank" rel="noopener noreferrer">{paint.uri}</a>
                <span className="error-message">Error: {paint.status}</span>
              </div>
            ))}
            </div>
          </Col>
        </Row>
      )}
              


      {!showPaints && !showPaintError && (
      <Row>      
        <Col>
          <h2>Members ({team.teamMembers.length})</h2>
          <div>
          {team.teamMembers.map((member) => (
            <div key={member.driverId} className="team-member">
              <span className="xxlg">
                <img src={member.avatar} className="logo" />
                {member.name}
              </span>
              <span className="xsm"><img className="flag" src={`https://rf2-ui-images-prod.s3.eu-west-1.amazonaws.com/nation-flags/${member.nationality}.svg`} /></span>
              <span className="lg">{member.steamId}</span>
              <span className="lg">{member.roles.join(", ")}</span>
              <span className="md"><DriverRankBadge dr={member.driverRank} /></span>
              <span className="md"><SafetyRankBadge sr={member.safetyRank}/></span>
            </div>
          ))}

          </div>
        </Col>

        <Col>
          <h2>Lineups ({team.lineups.length})</h2>
          {team.lineups.map((lineup) => (
            <div key={lineup.id} className="team-lineup" style={{border: "1px solid #ccc", padding: "1rem", marginBottom: "1rem"}}>
              <div style={{display: "flex", justifyContent: "space-between"}}>
                <h4>{lineup.name}</h4>
                <span><DriverRankBadge dr={lineup.rating} /></span>
                <span><SafetyRankBadge sr={lineup.safety}/></span>
              </div>
              
              <div>
                {lineup.drivers?.map((driver) => (
                  <div key={driver.driverId} className="team-member">
                    <span className="xxlg">
                      <img src={driver.avatar} className="logo" />
                      {driver.name}
                    </span>
                    <span className="xsm"><img className="flag" src={`https://rf2-ui-images-prod.s3.eu-west-1.amazonaws.com/nation-flags/${driver.nationality}.svg`} /></span>
                    <span className="lg">{driver.steamId}</span>
                    <span className="lg">{driver.roles.join(", ")}</span>
                    <span className="md"><DriverRankBadge dr={driver.driverRank} /></span>
                    <span className="md"><SafetyRankBadge sr={driver.safetyRank}/></span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </Col>
      </Row>
      )}
    </div>
  );
}

export default ViewTeam;